import * as Vue from 'vue'
import App from './App.vue'
import mitt from 'mitt'
import './assets/less/index.less'
import api from './api'
import router from "./router";
import store from "./store";
import mixin from "./utils/mixin";
import VueLazyload from '@jambonn/vue-lazyload'
import {VueMasonryPlugin} from "vue-masonry";
import Vconsole from "vconsole";
import './assets/styles/responsive.css'  
// PC redirection logic
const userAgent = navigator.userAgent;
if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) {
}

const emitter = mitt()

const app = Vue.createApp(App)
app.config.globalProperties.$api = {...api}
app.config.globalProperties.emitter = emitter
// app.config.unwrapInjectedRef = true
app.provide('mitt', emitter)
app.mixin(mixin)
const loadImage = new URL('./assets/img/icon/img-loading.png', import.meta.url).href
app.use(VueLazyload, {preLoad: 1.3, loading: loadImage, attempt: 1})
let d = (new URLSearchParams('?' + window.location.href.split('?')[1])).get('d')
let vconsoleInstance = null
let isVconsoleEnabled = false

if (d === "1") {
    vconsoleInstance = new Vconsole()
    isVconsoleEnabled = true
}


app.use(VueMasonryPlugin)
app.use(router)
app.use(store)
app.mount('#app')

// 等待DOM加载完成后添加双击事件监听器
document.addEventListener('DOMContentLoaded', () => {
    return;
    let clickCount = 0
    let clickTimer = null
    
    // 桌面端鼠标双击事件
    document.addEventListener('click', (e) => {
        clickCount++
        
        if (clickCount === 1) {
            clickTimer = setTimeout(() => {
                clickCount = 0 // 重置计数
            }, 300) // 300ms内的双击才有效
        } else if (clickCount === 2) {
            clearTimeout(clickTimer)
            clickCount = 0
            e.preventDefault()
            toggleVconsole()
        }
    })
    
    // 移动端触摸双击事件
    let touchCount = 0
    let touchTimer = null
    
    document.addEventListener('touchend', (e) => {
        touchCount++
        
        if (touchCount === 1) {
            touchTimer = setTimeout(() => {
                touchCount = 0 // 重置计数
            }, 300) // 300ms内的双击才有效
        } else if (touchCount === 2) {
            clearTimeout(touchTimer)
            touchCount = 0
            e.preventDefault()
            toggleVconsole()
        }
    }, { passive: false })
    
    // 切换Vconsole状态的函数
    function toggleVconsole() {
        if (!isVconsoleEnabled) {
            vconsoleInstance = new Vconsole()
            isVconsoleEnabled = true
            console.log('🎯 已启动调试模式 - Vconsole已开启（双击触发）')
            // 添加视觉反馈
            if (navigator.vibrate) {
                navigator.vibrate(50) // 震动反馈
            }
        } else {
            if (vconsoleInstance) {
                vconsoleInstance.destroy()
                vconsoleInstance = null
            }
            isVconsoleEnabled = false
            console.log('❌ 已关闭调试模式 - Vconsole已关闭（双击触发）')
            // 添加视觉反馈
            if (navigator.vibrate) {
                navigator.vibrate([30, 50, 30]) // 双震动反馈
            }
        }
    }
})
